import Pane from '../../../components/Pane';
import { useIntl } from 'react-intl';
import { ReactComponent as ExclamationIcon } from '../../../../../../icons/exclamation-icon.svg';

const Message = () => {
  const { formatMessage } = useIntl();

  return (
    <Pane padding={12} margin={40}>
      <div className='integration__message--headline'>
        <ExclamationIcon />

        <span className='integration__message--red'>{formatMessage({ id: 'Attention' })}</span>
      </div>

      <div className='integration__message--description'>{formatMessage({ id: 'Integration productions message' }, { br: <br /> })}</div>
    </Pane>
  );
};

export default Message;
